import React from "react"
import "../../css/Resources.css"

export default function Home() {

    return (
        <div className="resources--mainDiv text-9xl h-2/3">
            <h1 className='app--title text-white md:text-8xl text-6xl'>Hi, I'm Gareth</h1>
        </div>
    )
}